export default {
    data() {
        return {
            errors: [],
            errorMessage: '',
        }
    },
    methods: {
        setErrorMessage(message) {
            this.errorMessage = message;
        },
        resetErrorMessage() {
            this.errorMessage = '';
        },
        addError(message) {
            this.errors.push(message);
        },
        setValidationErrors(error) {
            this.errors = Object.values(error.response.data.errors).flat();
        },
        setErrors(errors) {
            this.errors = errors;
        },
        resetErrors() {
            this.errors = [];
        },
    }
}
